<div class="grid-section">
	<div class="form-area">
		<div class="container">
			<div class="logo"><img alt="" src="assets/images/signup/sign-up.png" /></div>
			<div class="title">Hello {{ decodeJwtToken.user_firstname }}</div>
			<div class="sub-title">Nice meeting you, just one step left</div>

			<div class="form-btn"></div>

			<div class="footer-link">
				Got a question?
				<a href="https://www.filed.com/contact-us-filed/">Don't worry. We here to help you</a>
			</div>
		</div>
	</div>
</div>
